import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import { Table } from 'reactstrap';
import imgAnn from '../../../../static/images/announcement.svg';
import { IDeletedFileListPageProps, IDeletedFileListPageState } from '../../../../models/pages/addedActivityFiles';
import { FilterInitialValues } from '../../../../models/pages/addedActivityFiles';
import { Confirm, Notification } from '../../../../components/notification/main';
import SortedColumn from '../../../../components/table/sorted-column';
import DisplayFileIcon from '../../../../components/lesson/course-files/file-icons';
import * as Icons from 'react-icons/md';
import Moment from 'moment';
import Paginate from '../../../../components/table/paginate';
import { Formik, FormikActions, FormikProps } from 'formik';
import { IPagedQueryS } from '../../../../models/components/paginate';
import Input from '../../../../components/input/text/input-formik';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import {
    IFilterAddedActivityFile
} from '../../../../models/components/storage-management';
import * as Actions from '../../../../store/actions/storageManagement';
import Loading from '../../../../components/loading/loading';
import ContentLoader from 'react-content-loader';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class DeletedFileList extends React.Component<IDeletedFileListPageProps, IDeletedFileListPageState> {
    public state: IDeletedFileListPageState = {
        filters: Object.assign({}, FilterInitialValues),
        all_ids: [],
        selected_ids: [],
        goToTermListPage: false,
        termId: '',
        termName: '',
        filterInitialValues: {
            termId: '',
            tabName: 'deletedFiles',
            isDeleted: true,
            fileName: "",
            fileOwner: "",
            fileDate: "",
            page: 1,
            take: 10
        },
        loading: false
    };

    constructor(props: any) {
        super(props);
        this.onSubmit.bind(this);
    }

    

    componentDidMount() {
        this.getActivityFileList(this.state.filterInitialValues, this.state.filters);
    }

    public callbackActivityFileList(this: any)
    {
        this.setState({loading: false});
    }

    getActivityFileList = async (filters: IFilterAddedActivityFile, paging: IPagedQueryS) => {
        filters.termId = this.props.routerLocation.query.term_id
        this.props.dispatch(Actions.ActivityFilesListByTerm(filters, paging, 'getDeletedFilesListByTerm', 'get', this.callbackActivityFileList.bind(this)));
        this.setState({ filterInitialValues: filters , loading: true});
    };

    //#region delete

    restoreSelectedFileConfirmClick = () => {
        Confirm.setConfirm(
            'normal',
            this.restoreSelected,
            T.t('r_restore_files_selected'),
            null,
            null,
            undefined,
            undefined,
            null,
            undefined,
            T.t('r_remove_selected')
        );
    };

    restoreSelectedCallBack = async () => {
        await this.getActivityFileList(this.state.filterInitialValues, this.state.filters).then(() => {
            this.setState({
                selected_ids: [],
                all_ids: []
            });
        });
    };

    restoreSelected = () => {
        if ((this.state.selected_ids && this.state.selected_ids.length) || this.state.all_ids) {
            this.props.dispatch(
                Actions.RestoreActivityFiles(
                    this.state.selected_ids,
                    this.restoreSelectedCallBack,
                    '',
                    'get'
                )
            );
        }
    };

    //#endregion delete

    public sort = (sortKey: string, orderBy: string) => {
        this.state.filters.orderBy = sortKey + '_' + orderBy;
        this.setState(this.state);
        this.getActivityFileList(this.state.filterInitialValues, this.state.filters);
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        await this.getActivityFileList(this.state.filterInitialValues, this.state.filters);
        this.state.filters.page = 1;
    };

    onSubmit = async (model: any, FormActions: FormikActions<any>) => {
        await this.getActivityFileList(model, this.state.filters);
        FormActions.setSubmitting(false);
    };

    checkAllIdsSelected = (): boolean => {
        const all_ids = this.state.all_ids ? this.state.all_ids : [];
        const selected_ids = this.state.selected_ids ? this.state.selected_ids : [];
        let result: boolean = false;
        if (all_ids.length && selected_ids.length) {
            result = all_ids.every((item: any) => selected_ids.indexOf(item) !== -1);
        }
        return result;
    };

    handleReset = (formikValue:any) => {
        formikValue.values.fileName = "";
        formikValue.values.fileOwner = "";
        formikValue.values.fileDate = "";
        formikValue.resetForm();
    };

    onSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e && e.currentTarget) {
            if (e.currentTarget.checked) {
                const all_ids = this.props.results!.map((item: any) => item.id);
                this.setState({
                    ...this.state,
                    all_ids: all_ids,
                    selected_ids: all_ids
                });
            } else {
                this.setState({
                    ...this.state,
                    all_ids: [],
                    selected_ids: [],
                    filters: {
                        ...this.state.filters,
                        select_all: false
                    }
                });
            }
        }
    };

    onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e && e.currentTarget) {
            let checkedList = Object.assign([], this.state.selected_ids);
            let stringID: string = e.currentTarget.dataset.id || '';

            if (e.target.checked) {
                checkedList.push(stringID);
            } else {
                let index = checkedList.indexOf(stringID);
                if (index !== -1) {
                    checkedList.splice(index, 1);
                }
                this.setState({
                    ...this.state,
                    filters: {
                        ...this.state.filters,
                        select_all: false
                    }
                });
            }
            this.setState({
                ...this.state,
                selected_ids: checkedList
            });
        }
    };

    validateAndSubmit = async (formik: FormikProps<any>) => {
        let isCompleted: boolean = true;

        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                'topRight'
            );

            isCompleted = false;
        });
        if (isCompleted) {
            formik.submitForm();
        }
        const searched = document.getElementById('searched');
        const unsearched = document.getElementById('unsearched');
        if (unsearched && searched) {
            unsearched.className = "d-none";
            searched.className = "d-block";
        }
    };

    public render() {
        const loadingSpaces = 483;

        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                    <Formik
                        initialValues={this.state.filterInitialValues}
                        onSubmit={this.onSubmit}
                    >
                        {formik => {
                            return (
                                <>
                                    <div className="filter-fields" style={{ margin: "-15px -15px 0px -15px" }}>
                                        <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                            <div className="row align-items-baseline">
                                                <div className="col-4">
                                                    <div className="form-input form-group date-picker">
                                                        <Input
                                                            type={'text'}
                                                            name={'fileName'}
                                                            label={T.t('r_file_name')}
                                                            formik={formik}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-input form-group date-picker">
                                                        <Input
                                                            type={'text'}
                                                            name={'fileOwner'}
                                                            label={T.t('r_activity_file_owner')}
                                                            formik={formik}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-12">
                                                    <div className="form-input form-group date-picker">
                                                        <DatetimeFormik
                                                            name={'fileDate'}
                                                            placeHolder={T.t('r_file_upload_date')}
                                                            formik={formik}
                                                            datePickerId={'fileDate'}
                                                            mode="single"
                                                            dateFormat={'YYYY-MM-DD'}
                                                            time24Hr={true}
                                                            static={true}
                                                            onChange={this.state.filterInitialValues.fileDate ? this.state.filterInitialValues.fileDate : null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row pt-3'>
                                                <div className="col" style={{ paddingBottom: 10, textAlign: "start" }}>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#report-modal"
                                                        className="category-tag-square tag-gray"
                                                        type="reset"
                                                        onClick={() =>  this.handleReset(formik)}
                                                    >
                                                        <i className="material-icons mr-2">clear</i>
                                                        {T.t('r_gen_clear')}
                                                    </button>
                                                </div>
                                                <div className="col text-right" style={{ paddingBottom: 10 }}>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#report-modal"
                                                        className="category-tag-square tag-green"
                                                        onClick={() => this.validateAndSubmit(formik)}
                                                        disabled={formik.isSubmitting}
                                                    >
                                                        <i className="material-icons mr-2">search</i>
                                                        {T.t('r_gen_search')}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </>
                            );
                        }}
                    </Formik>
                    <div className="question-list mt-3">
                        <div className="info-box" style={{ margin: "0px -12px 0px -12px" }}>
                            <p>
                                {T.t('r_gen_deleted_files_info')}
                                <b>{T.t('r_gen_deleted_files_info_1')}</b>
                                {T.t('r_gen_deleted_files_info_2')}
                            </p>
                        </div>
                    </div>
                    <div className='row d-flex justify-content-end mt-3'>
                        <button
                            className={'ml-3 category-tag-square' + ((this.state.selected_ids && this.state.selected_ids.length > 0) || (this.state.all_ids && this.state.all_ids.length > 0) ? ' tag-green' : ' tag-gray')}
                            onClick={this.restoreSelectedFileConfirmClick}
                            disabled={(this.state.selected_ids && this.state.selected_ids.length > 0) || (this.state.all_ids && this.state.all_ids.length > 0) ? false : true}>
                            <i className="material-icons mr-1">restore_from_trash</i>{T.t('r_remove_selected')}
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-md-12 p-0">
                            <div className="page-table p-0 m-t-0" id="getCourseFiles_Content">
                                {this.props.results && this.props.results.length > 0 ? (
                                    <Table
                                        className="table-user-list table-ellipsis table-mobile"
                                        striped={true}
                                        hover={true}
                                        borderless={true}
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                <th data-cell="select">
                                                    <div className="tick-radio position-relative">
                                                        <input
                                                            id='select_all'
                                                            type="checkbox"
                                                            className="form-radio"
                                                            checked={this.checkAllIdsSelected()}
                                                            onChange={this.onSelectAll}
                                                        />

                                                    </div>
                                                </th>
                                                <th style={{ maxWidth: '10px' }}>
                                                    {this.state.selected_ids && this.state.selected_ids.length ?
                                                        <span className="ml-2">{this.state.selected_ids.length}</span>
                                                        : null}
                                                </th>
                                                <SortedColumn
                                                    datacell="name"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_file_name')}
                                                    sortkey="FileName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="size"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_file_size')}
                                                    sortkey="FileSize"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="activity_type"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_activity_type')}
                                                    sortkey="ActivityType"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="activity_name"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_activity_name')}
                                                    sortkey="ActivityName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="week"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_course_page_week')}
                                                    sortkey="Week"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="week_name"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_course_name')}
                                                    sortkey="WeekName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="createdDate"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_upload_time')}
                                                    sortkey="CreatedDate"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="fullName"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_activity_file_owner')}
                                                    sortkey="FullName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="deletingDate"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_deleting_date')}
                                                    sortkey="DeletingDate"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="deletedUser"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_deleted_user')}
                                                    sortkey="DeletedUser"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.props.results.map((item: any) => {
                                                    const icon: any = DisplayFileIcon(item) || <Icons.MdInsertDriveFile size="22" />;
                                                    return (
                                                        <tr key={'course-file-' + item.id + item.week} data-title={item.fileName + '-' + item.fileName}>
                                                            <td data-cell="select">
                                                                <div className="tick-radio position-relative">
                                                                    <input
                                                                        id='select_course'
                                                                        type="checkbox"
                                                                        className="form-radio"
                                                                        checked={
                                                                            this.state.selected_ids &&
                                                                            this.state.selected_ids.indexOf(item.id ? item.id : -1) > -1
                                                                        }
                                                                        data-id={item.id}
                                                                        onChange={this.onSelectFile}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td data-label={T.t('r_file_name')} scope="row" style={{textAlign: "start"}}>
                                                                {icon}&nbsp;
                                                                {item.fileName}
                                                            </td>
                                                            <td data-label={T.t('r_video_file_size')} className="text-center">
                                                                {_common.BytesToSize(item.s3FileSize)}
                                                            </td>
                                                            <td data-label={T.t('r_activity_name')} className="text-center">
                                                                {item.activityName}
                                                            </td>
                                                            <td data-label={T.t('r_activity_type')} className="text-center">
                                                                {item.activityType}
                                                            </td>
                                                            <td data-label={T.t('r_course_page_week')} className="text-center">
                                                                {item.week
                                                                    ? item.week
                                                                    : T.t('r_gen_week_count').replace('{0}', '0')}
                                                            </td>
                                                            <td data-label={T.t('r_course_name')} className="text-center">
                                                                {item.courseName}
                                                            </td>
                                                            <td data-label={T.t('r_upload_time')} className="text-center">
                                                                {item.s3FileLastModified
                                                                    ? Moment(item.s3FileLastModified).format(
                                                                        _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 1) +
                                                                        ' HH:mm'
                                                                    )
                                                                    : T.t('r_gen_unspecified')}
                                                            </td>
                                                            <td data-label={T.t('r_activity_file_owner')} style={{ maxWidth: '30px' }} className="text-center">
                                                                {item.ownerName == null ? '-' : item.ownerName}
                                                            </td>
                                                            <td data-label={T.t('r_deleting_date')} className="text-center">
                                                                {item.deletedDate
                                                                    ? Moment(item.deletedDate).format(
                                                                        _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 1) +
                                                                        ' HH:mm'
                                                                    )
                                                                    : T.t('r_gen_unspecified')}
                                                            </td>
                                                            <td data-label={T.t('r_deleted_user')} className="text-center">
                                                                {item.deletedUserName == null ? '-' : item.deletedUserName}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                ) : (this.state.loading) ?(
                                    
                                       <div
                                            className="d-flex flex-column align-items-center justify-content-center"
                                        >
                                         <div className="col-md-12 p-0">

                                          <Loading spinnerId={'getDeletedFilesListByTerm'}>
                <div className="col-md-12 p-0" style={{ backgroundColor: '#eeede9', height: '250px' }}>
                    <ContentLoader
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        viewBox="0 0 1000 400"
                        className="course_list_lazy_loader"
                    >

                        <rect x="5" y="0" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y="0" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y="0" rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y="0" rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />


                        <rect x="5" y="55" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y="55" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y="55" rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y="55" rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y={60 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={60 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={60 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={60 + loadingSpaces} rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y={60 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={60 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={60 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={60 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y="110" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y="110" rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y="110" rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y="110" rx="3" ry="3" width="250" height="50" />
                        <rect x="5" y={115 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={115 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={115 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={115 + loadingSpaces} rx="3" ry="3" width="250" height="50" />

                        <rect x="5" y={115 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="261" y={115 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                        <rect x="517" y={115 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
                        <rect x="773" y={115 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />

                    </ContentLoader>
                </div>
                </Loading>
                                        </div>
                                        </div>
                                    
                                )
                                :(
                                    <>
                                    <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />

                                    <h5 id='unsearched' className='d-block' style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                        {
                                            T.t('r_error_no_document')
                                        }
                                    </h5>
                                </>     
                                )}
                                <div className="row-options justify-content-end">
                                    <div
                                        className="page-sorting d-flex align-items-center justify-content-center"
                                        style={{ marginTop: '5px' }}
                                    />
                                    {this.props.results && this.props.results.length > 0 && (
                                        <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IDeletedFileListPageProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IDeletedFileListPageProps = Object.assign({}, ownProps, {
        results: state.storageManagement.deletedFilesListByTerm.results,
        filters: state.storageManagement.deletedFilesListByTerm.filters,
        routerLocation: state.router.location
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.storageManagement.deletedFilesListByTerm.results === prev.storageManagement.deletedFilesListByTerm.results &&
        next.storageManagement.deletedFilesListByTerm.filters === prev.storageManagement.deletedFilesListByTerm.filters
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CDeletedFileList = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(DeletedFileList);

export default CDeletedFileList;